import { Sheet, Typography } from "@mui/joy";
import {
    faPause,
    faPlay,
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect } from "react";
import PageLooperContext from "../../providers/PageLooperContext";

const ActionZone = () => {
    const {
        isPlaying,
        setIsPlaying,
        pages,
        nextPage,
        setCurrentIndex,
    } = useContext(PageLooperContext);

    const prevPage = () => setCurrentIndex((prev: number) => (prev === 0 ? pages.length - 1 : prev - 1));
    const firstPage = () => setCurrentIndex(0);
    const lastPage = () => setCurrentIndex(pages.length - 1);

    useEffect(() => {
        const handleKey = (e: KeyboardEvent) => {
            switch (e.key) {
                case "Tab":
                case " ":
                    e.preventDefault();
                    setIsPlaying((p: boolean) => !p); break;
                case "ArrowRight": nextPage(); break;
                case "ArrowLeft": prevPage(); break;
                case "ArrowUp": lastPage(); break;
                case "ArrowDown": firstPage(); break;
            }
        };

        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [pages]);

    return (
        <Sheet
            variant="soft"
            sx={{
                position: "fixed",
                bottom: '2vh',
                right: '2vw',
                px: 2,
                py: 1,
                borderRadius: "xl",
                boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                backgroundColor: 'rgba(255,255,255,0.95)',
                backdropFilter: 'blur(8px)',
            }}
        >
            <Typography
                level="body-md"
                textAlign="center"
                fontSize="1vw"
                onClick={() => setIsPlaying(p => !p)}
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} /> Tab
            </Typography>
            <Typography
                level="body-md"
                textAlign="center"
                fontSize="1vw"
                onClick={prevPage}
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faArrowLeft} /> Précédent
            </Typography>
            <Typography
                level="body-md"
                textAlign="center"
                fontSize="1vw"
                onClick={nextPage}
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faArrowRight} /> Suivant
            </Typography>
            <Typography
                level="body-md"
                textAlign="center"
                fontSize="1vw"
                onClick={lastPage}
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faArrowUp} /> Dernière
            </Typography>
            <Typography
                level="body-md"
                textAlign="center"
                fontSize="1vw"
                onClick={firstPage}
                sx={{ cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faArrowDown} /> Première
            </Typography>
        </Sheet>
    );
};

export default ActionZone;